import { render, staticRenderFns } from "./qcSuper.vue?vue&type=template&id=53b31d18&scoped=true"
import script from "./qcSuper.vue?vue&type=script&lang=js"
export * from "./qcSuper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b31d18",
  null
  
)

export default component.exports